import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPropertyDocumentsMutationVariables = Types.Exact<{
  objects: Array<Types.Property_Documents_Insert_Input> | Types.Property_Documents_Insert_Input;
}>;


export type AddPropertyDocumentsMutation = { __typename?: 'mutation_root', insert_property_documents?: { __typename?: 'property_documents_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'property_documents', id: any, property_id: any, name?: string | null, description?: string | null, type?: string | null, mime_type?: string | null, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed?: boolean | null, created_at?: any | null, updated_at?: any | null, handover_id?: any | null }> } | null };


export const AddPropertyDocumentsDocument = gql`
    mutation addPropertyDocuments($objects: [property_documents_insert_input!]!) {
  insert_property_documents(objects: $objects) {
    affected_rows
    returning {
      id
      property_id
      name
      description
      type
      mime_type
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      created_at
      updated_at
      handover_id
    }
  }
}
    `;
export type AddPropertyDocumentsMutationFn = Apollo.MutationFunction<AddPropertyDocumentsMutation, AddPropertyDocumentsMutationVariables>;

/**
 * __useAddPropertyDocumentsMutation__
 *
 * To run a mutation, you first call `useAddPropertyDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyDocumentsMutation, { data, loading, error }] = useAddPropertyDocumentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddPropertyDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyDocumentsMutation, AddPropertyDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyDocumentsMutation, AddPropertyDocumentsMutationVariables>(AddPropertyDocumentsDocument, options);
      }
export type AddPropertyDocumentsMutationHookResult = ReturnType<typeof useAddPropertyDocumentsMutation>;
export type AddPropertyDocumentsMutationResult = Apollo.MutationResult<AddPropertyDocumentsMutation>;
export type AddPropertyDocumentsMutationOptions = Apollo.BaseMutationOptions<AddPropertyDocumentsMutation, AddPropertyDocumentsMutationVariables>;